import { api } from './api';
import type {
  Partner, PartnerCreateRequest, PartnerUpdateRequest, PaginatedResponse, QueryParams, RescopePreview,
} from '../types/partners';

export const partnersService = {
  getAll: async (params?: QueryParams): Promise<PaginatedResponse<Partner>> => {
    const res = await api.get<PaginatedResponse<Partner>>('/api/v1/partners/list', { params });
    return res.data;
  },
  getAllForDropdown: async (): Promise<Partner[]> => {
    const res = await api.get<PaginatedResponse<Partner>>('/api/v1/partners/list', {
      params: { page: 1, page_size: 500, include_deleted: false },
    });
    return res.data.data || [];
  },
  getById: async (id: string): Promise<Partner> => {
    const res = await api.get<{ data: Partner }>(`/api/v1/partners/get/${id}`);
    return res.data.data;
  },
  // appId sets the owning project for an INTERNAL partner (ignored for CUSTOMER,
  // which is global). Omitted → the caller's own project.
  create: async (data: PartnerCreateRequest, appId?: string | null) =>
    (await api.post('/api/v1/partners/create', data, { params: appId ? { app_id: appId } : undefined })).data,
  update: async (id: string, data: PartnerUpdateRequest) => (await api.put(`/api/v1/partners/update/${id}`, data)).data,
  delete: async (id: string) => (await api.delete(`/api/v1/partners/delete/${id}`)).data,
  restore: async (id: string) => (await api.patch(`/api/v1/partners/restore/${id}`)).data,

  // Preview moving a partner (and its connections) to another project.
  getRescopePreview: async (id: string, appId?: string | null): Promise<RescopePreview> => {
    const res = await api.get<{ data: RescopePreview }>(
      `/api/v1/partners/${id}/rescope-preview`,
      { params: { app_id: appId || undefined } },
    );
    return res.data.data;
  },
  // Change a partner's project; its connections move with it.
  rescopeProject: async (id: string, appId: string): Promise<Partner> => {
    const res = await api.patch<{ data: Partner }>(`/api/v1/partners/${id}/project`, { appId });
    return res.data.data;
  },
};
